import { IconDefinition } from "./types";

const circleDollar: IconDefinition = {
  iconName: "circle-dollar",
  width: 512,
  height: 512,
  svgPathData:
    "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392l-48 0 0 32.3c-31.5 3.3-56 29.9-56 62.2 0 31.1 22.9 57.5 53.7 61.9l45.8 6.5c7.2 1 12.5 7.2 12.5 14.4 0 8-6.5 14.6-14.6 14.6l-89.4 0 0 48 48 0 0 32 48 0 0-32.3c31.5-3.3 56-29.9 56-62.2 0-31.1-22.9-57.5-53.7-61.9L236.5 229c-7.2-1-12.5-7.2-12.5-14.4 0-8 6.5-14.6 14.6-14.6l81.4 0 0-48-40 0 0-32z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "circle-dollar",
  unicode: 0xf2e8,
};

export { circleDollar };
